import React, { useMemo } from "react"
import { useHistory } from "react-router-dom"
import SButton from "components/Common/Button"
import TableContainer from "components/newTables/TableContainer"

const Table = ({ content, page, size, count, params, setParams }) => {
  const history = useHistory()

  const listDataTable = useMemo(() => {
    if (!content) return []
    return content.map((v, i) => ({
      no: v.id,
      name: v.productName,
      category: v.categoryName,
      id: v.id,
      idx: v.id,
    }))
  }, [content])

  const columns = useMemo(
    () => [
      {
        Header: "商品名",
        accessor: "name",
        defaultCanSort: false,
      },
      {
        Header: "商品カテゴリ名",
        accessor: "category",
        defaultCanSort: false,
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(
                  `/master/product/create?id=${cell.row.original.id}`
                )
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  return content?.length === 0 ? (
    <h3 className="text-center">No Data to Display</h3>
  ) : (
    <TableContainer
      page={page}
      size={size}
      count={count}
      params={params}
      setParams={setParams}
      columns={columns}
      data={listDataTable}
      pagination
    />
  )
}

export default Table
